<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">I would like to recognize particular people who in time contributed to the development of this book. Clyde Vicenti was an Apache Indian. We were very close friends. A Brahman bull rider, he was involved in many rodeo competitions. Clyde often related to me how he and his people considered us Hispanics, through our long history in New Mexico, to be very close to them. Doria Purcell, an Algonquin Indian, was a strong proponent of equal justice for Native Americans and was an activist in the “Red Power” movement while we were in college. Doria was often aghast that many Indian tribes, including the Pueblo, were so complacent during movements for social justice prevalent in New Mexico and the rest of the country. Chris Pasquale was a Pueblo Indian and fellow student at the University of Albuquerque. We spent many times together talking. She mentioned how concerned she was that her people were losing their native languages and that she was involved in trying to make a difference. The contributions of Pueblo Indian artist Lena J. Munoz is very much appreciated and acknowledged.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?ea4c32e4